import { Input, SingleDatePicker } from '@salecycle/ui-component-library';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';
import { useStartDate } from './hooks/useStartDate';
import { useStartTime } from './hooks/useStartTime';

const Container = styled.div`
  display: flex;
  flex-direction: row;
  gap: ${({ theme }) => theme.designToken.spacing2};
`;

export const StartDateAndTimeControl = () => {
  const { t } = useTranslation('campaigns');

  const { startDate, validation, ...startDateRest } = useStartDate();
  const { startTime, onStartTimeChanged } = useStartTime();

  return (
    <Container>
      <SingleDatePicker
        date={startDate}
        width="100px"
        label={t('onsite.editor.workflow.scheduling.startDate')}
        ariaLabel={t('onsite.editor.workflow.scheduling.startDateAria')}
        placeholder={t('onsite.editor.workflow.scheduling.startDatePlaceholder')}
        validationState={validation.passed ? '' : 'warning'}
        validationMessage={validation.passed ? undefined : validation.validationMessage}
        spacingBelow={false}
        {...startDateRest}
      />
      {startDate && (
        <Input
          value={startTime}
          onChange={onStartTimeChanged}
          ariaLabel={t('onsite.editor.workflow.scheduling.startTimeAria')}
          label={t('onsite.editor.workflow.scheduling.timeLabel')}
          type="time"
          style={{ width: 85, height: 50 }}
          spacingBelow={false}
        />
      )}
    </Container>
  );
};
